import { Country } from "../../Locations/Country";

export const updateCountryCode = (countryId: string | number, countries: Country[]) =>
  countries?.find((country) => country.Id === Number(countryId))?.CountryCode.toString() ?? "";
